var React = require('react');

function GameBoardAlt (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M480 0H32A32 32 0 0 0 0 32v448a32 32 0 0 0 32 32h448a32 32 0 0 0 32-32V32a32 32 0 0 0-32-32zm-31.8 448h-384V64h384z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M256 64v192h192V64zM64 448h192V256H64z","className":"fa-primary","key":2})]);
}

GameBoardAlt.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = GameBoardAlt;

GameBoardAlt.default = GameBoardAlt;
